<template>
    <div class="mb-5">
        <h1 class="page-title">Gérer la liste des références : {{titleMiddleMenu}}</h1>
    </div>
    <div class="card">
        <DataTable
            lazy
            :value="tableData"
            :paginator="true"
            :rows="rows"
            removableSort
            :loading="isLoading"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 100]"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            @page="onPaginate($event)"
            @sort="onSort($event)"
        >
            <template #header>
                <div class="flex flex-row flex-nowrap card-header border-0">
                    <div class="flex card-toolbar w-full">
                        <div class="w-full">
                          <span class="p-input-icon-left w-10/12">
                              <i class="pi pi-search" />
                              <InputText type="text" class="w-9/12" v-model="criteria" placeholder="Rechercher..." @keyup.enter="onSearchInputDt()" />
                          </span>
                        </div>
                    </div>
                    <div class="card-toolbar w-full">
                        <div class="flex flex-col justify-center">
                            <p>Nombre total : {{ totalRecords }}</p>
                        </div>
                        <div class="" v-if="type && type == 'travel'">
                            <img class="inline-block w-4 align-text-bottom" src="@/assets/img/info.png" alt="Your avatar" />  Les 6 premiers produits sont visibles sur la page d'accueil
                        </div>
                        <div class="" v-if="type && type == 'region'">
                            <img class="inline-block w-4 align-text-bottom" src="@/assets/img/info.png" alt="Your avatar" />  Les 8 premiers produits sont visibles sur la page d'accueil
                        </div>
                    </div>
                    <div class="card-toolbar w-full">
                        <div class="flex justify-end">
                            <Button size="small" class="btn btn-primary p-2 ps-2 pe-2" style="margin-right: 0.5em" title="Ajouter"
                            @click="router.push({ name: 'addMiddleMenuItem', params: { uuid: uuidRouteParam, blockType: type} })">Ajouter
                            </Button>
                            <Button size="small" class="btn btn-primary p-2 ps-2 pe-2" style="margin-right: 0.5em" title="Ajouter"
                                    @click="() => {
                                      if (type === 'region') {
                                        router.push({ name: 'regionList'})
                                      } else if (type === 'travel') {
                                        router.push({ name: 'travelList' })
                                      } else {
                                        router.push({ name: 'middleMenuList' })
                                      }
                                    }">Retour
                            </Button>
                        </div>
                    </div>
                </div>
            </template>

            <div class="card-body pt-0">
                <Column field="vignette" header="Miniature">
                    <template #body="slotProps">
                        <img v-if="slotProps.data.imageWeb" :src="slotProps.data.imageWeb.url" class="w-14" />
                    </template>
                </Column>
                <Column field="title" header="Titre" sortable>
                    <template #body="slotProps">
                        <span> {{ slotProps.data.title }} </span>
                    </template>
                </Column>
                <Column field="position" header="position" sortable>
                    <template #body="slotProps">
                        <span> {{ slotProps.data.position }} </span>
                    </template>
                </Column>
                <Column field="action" header="Action">
                    <template #body="slotProps">
                        <div class="d-flex flex-row whitespace-nowrap" >
                            <Button size="small" icon="pi pi-pencil" class="p-edition"
                                    style="margin-right: 0.5em" title="Éditer"
                                    @click="router.push({ name: 'editMiddleMenuItem', params: { uuid: slotProps.data.uuid, blockType: type } })">
                            </Button>
                            <Button size="small" icon="pi pi-trash" class="p-button-danger"
                                    style="margin-right: 0.5em" title="supprimer" @click="onDelete(slotProps.data)">
                            </Button>
                        </div>
                    </template>
                </Column>
            </div>
            <template #empty>Aucun produit ne correspond à votre recherche</template>
        </DataTable>
    </div>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import {ref, onMounted, computed} from 'vue';
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import swal from "@/_helpers/swal";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import {deleteMiddleMenuItem, fetchAll} from "@/_services/homepage/middleMenuItem";
import { useRoute, useRouter } from 'vue-router'
import {fetchByUuid} from "@/_services/homepage/middleMenu";
import {IMiddleMenu} from "@/models/homepage/IMiddleMenu";
const middleMenuItem = Array<IMiddleMenuItem>();
const middleMenu = Array<IMiddleMenu>();
const tableData = ref<Array<IMiddleMenuItem>>(middleMenuItem);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const route = useRoute();
const routerUse = useRouter();
const uuidRouteParam = ref<string>("");
const titleMiddleMenu = ref<string>("");

const allowedTypes = ['region', 'travel']

const type = computed(() => {
    const current = route.params.type as string | undefined
    return allowedTypes.includes(current ?? '') ? current : null
})

if (route.params.type && !allowedTypes.includes(route.params.type as string)) {
    router.replace({ name: 'middleMenuItemList' })
}

onMounted(async () => {
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    await hydrateTitleMiddleMenu(uuidRouteParam.value);
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});


const hydrateTitleMiddleMenu = async (uuid) => {
    const middleMenu = await fetchByUuid(uuid);
    titleMiddleMenu.value = middleMenu.title;
}

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchAll(
        uuidRouteParam.value,
        itemsPerPage,
        page,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const onSearchInputDt = () => {
    if (0 === criteria.value.length || 3 <= criteria.value.length) {
        populateDatatable(
            rows.value,
            page.value,
            "" != criteria.value ? criteria.value : ""
        );
    }
}

const onDelete = (data: IMiddleMenuItem) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteMiddleMenuItem(data.uuid).then((result) => {
                    if (result) {
                        swal.success("succés !", "Suppression effectuée avec succès");
                    }
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};
</script>